import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFireAuth } from 'angularfire2/auth';
import { NavItem } from './core/navbar/nav-item';
import { ObjectObservable } from './shared/base/object-observable';
import { User } from './users/shared/user';
import { UserService } from './users/shared/user.service';
import { APPCONFIG } from "./config";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  title = 'NEXTSTEP';
  userObservable: ObjectObservable<User>;
  navItems: NavItem[] = [
    {
      text: 'Home',
      commands: ['/intro']
    },
    {
      text: 'Courses',
      commands: ['/courses']
    },
    {
      text: 'Lectures',
      commands: ['/lectures']
    }
  ];
  themes: String[] = ['theme-brown','theme-powderblue','theme-silver', 'theme-bisque'];

  private AppConfig: any;

  constructor(
    private router: Router,
    private afAuth: AngularFireAuth,
    private userService: UserService) { }

  ngOnInit() {

    this.AppConfig = APPCONFIG;

    this.afAuth.authState.subscribe(auth => {
      if (auth == null) {
        this.router.navigateByUrl('/intro');
      } else {
        this.userObservable = this.userService.readChild(auth.uid);
        this.userService.readChild(auth.uid).subscribe(u => {

          if(u.colorTheme) {
            this.AppConfig.theme = u.colorTheme;
          }

          if (this.router.url === '/') {
            if (u.latestLessonUrl) {
              this.router.navigateByUrl(u.latestLessonUrl);
            } else {
              this.router.navigateByUrl('/intro');
            }
          }
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/app.component.ts